<template>
  <div>
    <section class="top">
      <!-- <a :href="props.quick_start" target="_blank" class="first--a">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 43.65 43.65"
          width="40px"
          heigth="40px"
        >
          <path
            id="Path_610"
            data-name="Path 610"
            class="cls-1"
            d="M43.65,20.475c-2.475-6.525-9-9.9-16.2-8.55C20.475,4.95,10.8.225,1.125,0A1.063,1.063,0,0,0,0,1.125C.225,10.8,4.95,20.475,11.7,27.45c-1.125,6.975,2.025,13.725,8.55,16.2a15.672,15.672,0,0,1-.45-9.675,24.592,24.592,0,0,0,3.375,1.8,1.06,1.06,0,0,0,1.35-.225L35.775,24.3a1,1,0,0,0,0-1.125,14.345,14.345,0,0,0-1.8-3.15A15.672,15.672,0,0,1,43.65,20.475ZM18.9,18.9a4.455,4.455,0,0,1-6.3-6.3,4.455,4.455,0,0,1,6.3,6.3Z"
            transform="translate(0)"
          ></path>
        </svg>
        &nbsp;
        {{translation.quick_start}}
      </a> -->
      <a :href="props.facebook" target="_blank">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 23.418 45" width="40px" heigth="40px">
          <path
            id="Path_3"
            data-name="Path 3"
            class="cls-blue"
            d="M237.182,174.856v-22.53h8.289l1.31-7.466h-9.6v-3.744c0-1.948.712-3.808,3.83-3.808h6.231v-7.452H238.4c-7.438,0-9.468,4.393-9.468,10.483v4.517h-5.1v7.47h5.1v22.53Z"
            transform="translate(-223.825 -129.856)"
          ></path>
        </svg>
        &nbsp;
        {{translation.fb_group}}
      </a>
      <a :href="props.youtube" target="_blank">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 14.075" width="40px" heigth="40px">
          <g id="youtube" transform="translate(0 -45.917)">
            <path
              class="cls-blue cls-1"
              id="XMLID_823_"
              d="M19.22,47.125c-.722-.858-2.055-1.208-4.6-1.208H5.38c-2.6,0-3.959.373-4.679,1.286-.7.891-.7,2.2-.7,4.02v3.463c0,3.519.832,5.306,5.38,5.306h9.24c2.207,0,3.431-.309,4.222-1.066.812-.777,1.158-2.045,1.158-4.24V51.223C20,49.308,19.946,47.987,19.22,47.125Zm-6.38,6.307-4.2,2.193a.645.645,0,0,1-.944-.572V50.682a.645.645,0,0,1,.943-.573l4.2,2.179a.645.645,0,0,1,0,1.144Z"
            ></path>
          </g>
        </svg>
        &nbsp;
        {{translation.youtube_channel}}
      </a>
      <a :href="props.rota_office_support" target="_blank">
        <svg
          id="icon_suporte"
          data-name="icon suporte"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 45 45"
          width="40px"
          heigth="40px"
        >
          <rect
            id="Rectangle_30"
            data-name="Rectangle 30"
            class="cls-2"
            width="40"
            height="40"
            transform="translate(0)"
          ></rect>
          <path
            id="Path_60"
            data-name="Path 60"
            class="cls-blue"
            d="M8.886,27.043l1.52-1.327H21.524L14.43,14.524l-5.246.932A3.524,3.524,0,0,0,6.351,17.79L.123,35.537a2.9,2.9,0,0,0,.644,2.787A3.9,3.9,0,0,0,3.69,39.58h5.2Z"
            transform="translate(0 1.816)"
          ></path>
          <path
            id="Path_61"
            data-name="Path 61"
            class="cls-blue"
            d="M42.269,35.53,36.041,17.784a3.535,3.535,0,0,0-2.88-2.343l-5.227-.863L20.869,25.708H32.826l1.52,1.327V39.571H38.7a3.9,3.9,0,0,0,2.923-1.256A2.905,2.905,0,0,0,42.269,35.53Z"
            transform="translate(2.609 1.822)"
          ></path>
          <path
            id="Path_62"
            data-name="Path 62"
            class="cls-blue"
            d="M10.774,38.166v1.125H11.9V38.166Zm-.422,0V37.041H9.227v1.125Zm0,0H9.227V39.3h1.125Zm21.988,0v1.125h1.125V38.17Zm0,0V37.041H31.215v1.125Zm.42,0v1.125h1.125V38.166Zm0-11.208h1.125V25.833H32.76Zm-21.987,0V25.833H9.649v1.125Zm0,10.082h-.422v2.25h.422ZM9.227,38.166v0h2.25v0Zm1.125,1.13H32.34v-2.25H10.352ZM33.465,38.17v0h-2.25v0ZM32.34,39.291h.42v-2.25h-.42Zm1.545-1.125V26.958h-2.25V38.166ZM32.76,25.833H10.774v2.25H32.76ZM9.649,26.958V38.166H11.9V26.958Z"
            transform="translate(1.153 3.229)"
          ></path>
          <path
            id="Path_63"
            data-name="Path 63"
            class="cls-blue"
            d="M38.494,37.867H5.2v2.4H38.494Z"
            transform="translate(0.651 4.733)"
          ></path>
          <path
            id="Path_64"
            data-name="Path 64"
            class="cls-blue"
            d="M13.561,12.58c.036.085.084.217.134.354a3.729,3.729,0,0,0,.588,1.208c1.045,3.922,3.741,6.637,6.605,6.627s5.515-2.75,6.521-6.683a3.772,3.772,0,0,0,.573-1.2c.049-.14.094-.272.13-.358a2.167,2.167,0,0,0-.287-2.4v-.09c-.013-4.868-.565-10.061-7-10.036-6.481.024-7.009,5-6.995,10.089,0,.031,0,.061,0,.09A2.174,2.174,0,0,0,13.561,12.58Zm.9-1.568L14.485,11a.5.5,0,0,0,.245-.239l1.122.2a.237.237,0,0,0,.256-.163l.709-1.885a26.81,26.81,0,0,0,6.225,1,5.876,5.876,0,0,0,1.825-.245l.45,1.25a.239.239,0,0,0,.22.17.244.244,0,0,0,.064-.01l1.307-.423a.52.52,0,0,0,.271.293l.018.007c.194.111.258.6.054,1.085-.049.117-.1.266-.157.423a4.449,4.449,0,0,1-.342.815.544.544,0,0,0-.223.33c-.855,3.557-3.18,6.048-5.65,6.057s-4.841-2.464-5.731-6.013a.541.541,0,0,0-.225-.327,4.558,4.558,0,0,1-.352-.819c-.055-.154-.109-.3-.159-.417C14.21,11.613,14.271,11.125,14.466,11.012Z"
            transform="translate(1.667 0)"
          ></path>
        </svg>
        &nbsp;
        {{translation.support}}
      </a>
      <a :data-toggle="notification" @click="changeNotification()" ref="notification">
        <svg
          id="notification"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 37.498 45"
          width="40px"
          heigth="40px"
        >
          <g id="Group_3" data-name="Group 3" transform="translate(0)">
            <g id="Group_2" data-name="Group 2">
              <path
                id="Path_4"
                data-name="Path 4"
                class="cls-blue"
                d="M80.04,37.955,76.82,32.588a15.94,15.94,0,0,1-2.272-8.2v-4.7A13.141,13.141,0,0,0,65.173,7.115V3.75a3.75,3.75,0,0,0-7.5,0V7.115A13.141,13.141,0,0,0,48.3,19.687v4.7a15.949,15.949,0,0,1-2.271,8.2l-3.219,5.366a.939.939,0,0,0,.8,1.421H79.235a.937.937,0,0,0,.8-1.419Z"
                transform="translate(-42.675)"
              ></path>
            </g>
          </g>
          <g id="Group_5" data-name="Group 5" transform="translate(12.844 41.25)">
            <g id="Group_4" data-name="Group 4">
              <path
                id="Path_5"
                data-name="Path 5"
                class="cls-blue"
                d="M188.815,469.333a6.523,6.523,0,0,0,11.808,0Z"
                transform="translate(-188.815 -469.333)"
              ></path>
            </g>
          </g>
        </svg>&nbsp;
        <span>
          <span v-if="notification == 2">{{translation.disable}}</span>
          <span v-else>{{translation.enable}}</span>
        </span>
        &nbsp;{{translation.notification}}
      </a>
    </section>
  </div>
</template>

<script>
// import merge from 'lodash-es/merge';

export default {
  name: "fast-links",
  props: ["props"],
  components: {},
  data() {
    return {
      notification: 1,
      translation: this.$parent.$parent.view.translation.fastLinks
    };
  },
  methods: {
    changeNotification() {
      let value = this.$refs.notification.dataset.toggle;
      this.notification = this.notification == 1 ? 2 : 1;

      var data = new FormData();
      data.append("toggle", this.notification);

      fetch(this.props.url_toggle_notification, {
        method: "POST",
        body: data
      });
    }
  },
  created() {
    this.notification = this.props.show_notification;
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.top {
  background: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 0 45px -15px;

  a {
    font-size: 1.27rem;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 45px;
    transition: 0.4s all;
    width: 100%;
    color: #0294ff;

    span {
      font-size: 1.27rem;
    }

    &:hover {
      background: #f7f9fd;
      color: #0294ff;
    }

    &.first--a {
      color: white;
      background: #48d29f;
      // flex: .1 0 300px;
      &:hover {
        background: rgba(73, 210, 159, 0.85) !important;
        color: white;
      }
    }

    svg {
      width: 20px;
      height: 20px;
    }
  }
}
.cls-1 {
  fill: #fff;
}

.cls-2 {
  fill: rgba(2, 148, 255, 0);
}

.cls-blue {
  fill: #0294ff;
}
@media (max-width: 1300px) {
  .top {
    flex-direction: column;
  }
}
</style>


// WEBPACK FOOTER //
// resources/office/js/components/franchise/components/fastLinks.vue